module.exports = __webpack_public_path__ + "img/img23.7c7ce57c.svg";